<template>
    <section id="pricing" style="padding-top: 5px;">
        <div class="container">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pricing">
                <h1>Subscribe to Devect</h1>
            </div>
        </div>
        <div class="container">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pricing-box">
                <div class="bgorange price" style="background: #58aabc;">
                    <div class="amount">$2</div>
                    <div class="duration">monthly</div>
                </div>
                <div class="featcontent">
                    <div class="feat-list">
                        <ul>
                            <li>Free 14-day trial</li>
                            <li>Up to 5 active tests</li>
                            <li>15 min interval</li>
                            <li>1 week data retention</li>
                            <li style="text-align: center">-</li>
                            <li style="text-align: center">-</li>
                        </ul>
                    </div>
                    <div class="blank-button" v-if="actual_plan == 572802"><a>Your plan</a></div>
                    <div class="signup-btn" v-else-if="actual_plan != 0" @click="_upgradeUser(572802)"><a>Change plan</a></div>
                    <div class="signup-btn" v-else><a @click="openPaddle(572802)">Start FREE trial</a></div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pricing-box">
                <div class="bgorange price" style="background: #007d99;">
                    <div class="amount">$29</div>
                    <div class="duration">monthly</div>
                </div>
                <div class="featcontent">
                    <div class="feat-list">
                        <ul>
                            <li>Free 14-day trial</li>
                            <li>Up to 25 active tests</li>
                            <li>1 min interval</li>
                            <li>6 months data retention</li>
                            <li>Email notifications</li>
                            <li style="text-align: center">-</li>
                        </ul>
                    </div>
                    <div class="blank-button" v-if="actual_plan == 572803"><a>Your plan</a></div>
                    <div class="signup-btn" v-else-if="actual_plan != 0" @click="_upgradeUser(572803)"><a>Change plan</a></div>
                    <div class="signup-btn" v-else><a @click="openPaddle(572803)">Start FREE trial</a></div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pricing-box">
                <div class="bgorange price" style="background: #58aabc;">
                    <div class="amount">$79</div>
                    <div class="duration">monthly</div>
                </div>
                <div class="featcontent">
                    <div class="feat-list">
                        <ul>
                            <li>Free 14-day trial</li>
                            <li>Up to 100 active tests</li>
                            <li>1 min interval</li>
                            <li>1 year data retention</li>
                            <li>Email notifications</li>
                            <li>SMS notifications</li>
                        </ul>
                    </div>
                    <div class="blank-button" v-if="actual_plan == 572804"><a>Your plan</a></div>
                    <div class="signup-btn" v-else-if="actual_plan != 0" @click="_upgradeUser(572804)"><a>Change plan</a></div>
                    <div class="signup-btn" v-else><a @click="openPaddle(572804)">Start FREE trial</a></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {intervalToText} from "../logic/endpoints"
    import {updateUser, upgradeUser} from "../logic/account"
    import {getJWTContent, getUserPlan} from "../logic/global"
    import constants from '../constants'

    export default {
        name: 'Plans',
        data(){
            return {
                actual_plan: null
            }
        },
        components: {},
        methods: {
            openPaddle: function(product_id){
                let _this = this;
                let user = getJWTContent();

                Paddle.Checkout.open({
                    product: product_id,
                    email: user["email"],
                    marketingConsent: true,
                    successCallback: function(data) {
                        if(data.checkout.completed){
                            updateUser(user["id"], {"plan": product_id}).then(response => {
                                _this.actual_plan = product_id
                                _this.showSuccessMsg("Thanks for Subscribing", "is-success");
                                setTimeout(function(){
                                    window.location.reload()
                                }, 1500)
                            }).catch(error => {
                                _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                            })
                        }else{
                            
                        }
                    }
                })
            },
            _upgradeUser: function(plan_id){
                let _this = this;
                let user = getJWTContent();

                upgradeUser(user["id"], plan_id).then(response => {
                    console.log(response)
                }).catch(error => {
                    console.log(error.response.data.error.message)
                    if(error.response && error.response.data && error.response.data.error && error.response.data.error.message){
                        _this.showSuccessMsg(error.response.data.error.message, "is-danger", 7000)
                    }else{
                        _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                    }
                })
            },
            showSuccessMsg: function(message, msg_type, duration=2000){
                this.$buefy.toast.open({message: message, type: msg_type, duration: duration})
            },
        },
        mounted: function() {
            let _this = this
            getUserPlan().then(response => {
                this.actual_plan = response.data.plan
                Paddle.Setup({vendor: 39076});
            }).catch(error => {
                _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            });
        }
    }
</script>

<style scoped>
.blank-button {
    padding-bottom: 25px;
}
.blank-button a{
    display: block;
    font-size: 20px;
    text-align: center;
    padding: 0px 30px 15px 30px;
    text-decoration: none;
}
/*----- Pricing section ----*/
#pricing
{
	padding-bottom:70px;
}

.pricing
{
	padding:50px 0 70px 0;
}

	.pricing h1
	{
		font-size: 32px !important;
		color: #007d99;
		font-weight: 900;
		text-align: center;
	}
	
	.pricing h2
	{
		color:#000;
		font-size:30px;
		text-align:center;
		margin:0px;
	}


.pricing-box
{
}
	.pricing-box .price
	{
		color:#fff;
		text-align:center;
		padding:50px 0;
	}
	
		.pricing-box .price .package
		{
			font-size:30px;
			font-weight:bold;
			
			
		}
		
		.pricing-box .price .divider
		{
			height:2px;
			background:rgba(255,255,255,.3);
			width:40px;
			margin:20px auto;
		}
		
		.pricing-box .price .amount
		{
			font-size:90px;
			font-weight:300;
			line-height:90px;
			
		}
		
		.pricing-box .price .duration
		{
			font-size:20px;
			font-weight:300;
			padding-top:10px;
		}
	
	.pricing-box .featcontent
	{
		background:#ffffff;
	}
	
		.pricing-box .featcontent .feat-list
		{
			font-size:16px;
			font-weight:300;
			color:#656667;
		}
		
			.pricing-box .featcontent .feat-list ul
			{
				list-style:none;
				margin:0px;
				padding:0px;
				margin-bottom:30px;
			}
			
			.pricing-box .featcontent .feat-list li
			{
				line-height: 45px;
				border-bottom:1px solid rgba(0,0,0,0.1);
				padding:0 30px;
			}
			
			.pricing-box .featcontent .feat-list li:last-child
			{
				border-bottom:none;
			}
		
		.pricing-box .featcontent .signup-btn
		{
			font-size:	20px;
			text-align:center;
			padding-bottom:40px;
			
		}
		
				.pricing-box .featcontent .signup-btn a
				{
					padding:15px 30px;
					background:#424a56;
					color:#fff !important;
					text-decoration:none;
					transition:ease-in-out;
					transition-duration:.3s;
				}

				.pricing-box .featcontent .signup-btn a:hover
				{

					background:#f87c45;
					color:#fff !important;
					text-decoration:none;
				}				

/*bg colors for packages*/

	.bgred
	{
		background:#e25858;

	}
	.bggreen
	{
		background-color:#6ad993;

	}
	.bgblue
	{
		background-color:#6abbd9;

	}
	.bgorange
	{
		background-color:#f87c45;

	}
	.bgpgreen
	{
		background-color:#98d96a;

	}
	.bgyellow
	{
		background-color:#fccf3c;

	}
	.bggray
	{
		background-color:#424a56;

	}
</style>
